module.exports = __webpack_public_path__ + "img/Korea.b6e69545.png";